/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportTaskStatus } from './ImportTaskStatus';
import {
    ImportTaskStatusFromJSON,
    ImportTaskStatusFromJSONTyped,
    ImportTaskStatusToJSON,
    ImportTaskStatusToJSONTyped,
} from './ImportTaskStatus';

/**
 * 
 * @export
 * @interface TaskProgressDto
 */
export interface TaskProgressDto {
    /**
     * 
     * @type {ImportTaskStatus}
     * @memberof TaskProgressDto
     */
    status?: ImportTaskStatus;
    /**
     * 
     * @type {number}
     * @memberof TaskProgressDto
     */
    totalRecords?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TaskProgressDto
     */
    processedRecords?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TaskProgressDto
     */
    progressPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof TaskProgressDto
     */
    recordsPerSecond?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TaskProgressDto
     */
    estimatedTimeRemaining?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskProgressDto
     */
    error?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TaskProgressDto
     */
    updatedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TaskProgressDto
     */
    startedAt?: Date | null;
}



/**
 * Check if a given object implements the TaskProgressDto interface.
 */
export function instanceOfTaskProgressDto(value: object): value is TaskProgressDto {
    return true;
}

export function TaskProgressDtoFromJSON(json: any): TaskProgressDto {
    return TaskProgressDtoFromJSONTyped(json, false);
}

export function TaskProgressDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskProgressDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : ImportTaskStatusFromJSON(json['status']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'processedRecords': json['processedRecords'] == null ? undefined : json['processedRecords'],
        'progressPercentage': json['progressPercentage'] == null ? undefined : json['progressPercentage'],
        'recordsPerSecond': json['recordsPerSecond'] == null ? undefined : json['recordsPerSecond'],
        'estimatedTimeRemaining': json['estimatedTimeRemaining'] == null ? undefined : json['estimatedTimeRemaining'],
        'error': json['error'] == null ? undefined : json['error'],
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'startedAt': json['startedAt'] == null ? undefined : (new Date(json['startedAt'])),
    };
}

export function TaskProgressDtoToJSON(json: any): TaskProgressDto {
    return TaskProgressDtoToJSONTyped(json, false);
}

export function TaskProgressDtoToJSONTyped(value?: TaskProgressDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': ImportTaskStatusToJSON(value['status']),
        'totalRecords': value['totalRecords'],
        'processedRecords': value['processedRecords'],
        'progressPercentage': value['progressPercentage'],
        'recordsPerSecond': value['recordsPerSecond'],
        'estimatedTimeRemaining': value['estimatedTimeRemaining'],
        'error': value['error'],
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'startedAt': value['startedAt'] == null ? value['startedAt'] : value['startedAt'].toISOString(),
    };
}

